import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'
import Select from "react-select";
import { Map as LeafletMap, TileLayer, FeatureGroup, Polyline } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import { PropTypes } from 'prop-types';

export class LaneDraftForm extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        let defaultMapCenter = window.defaultMapCenter;
        if (!Array.isArray(defaultMapCenter)) {
            defaultMapCenter = [41.15, -8.61024];
        }

        this.state = {
            countyEditions: [],
            center: defaultMapCenter,
            bounds: this.calculateBounds(props.form.obj),
        };

        this.customRefs = {
            saveChangesButton: React.createRef()
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateDraftCounty(edition) {
        this.setState({
            countyEditions: edition.objects.draftCounty
        });
    }

    // ----------------------

    onChangeEditMapStatus(bool, callback) {
        // Setting the state on this or on the parent component makes the map redraw an something very bad happens to it
        this.customRefs.saveChangesButton.current.disabled(bool);
        
        if("function" === typeof callback) {
            callback();
        }
    }

    // ----------------------

    calculateBounds(lane) {
        if (!Array.isArray(lane.segments) || 0 === lane.segments.length) {
            return [{ lat: 41.80582, lng: -6.75719 }, { lat: 37.10202, lng: -8.67422 }];
        }

        const bounds = lane.segments
            .reduce((output, value) => {
                return output.concat(value.breakpoints);
            }, [])
            .reduce((output, value) => {
                output.minLat = Math.min(output.minLat, value.latitude);
                output.maxLat = Math.max(output.maxLat, value.latitude);
                output.minLong = Math.min(output.minLong, value.longitude);
                output.maxLong = Math.max(output.maxLong, value.longitude);

                return output;
            }, { minLat: 90, maxLat: -90, minLong: 180, maxLong: -180 });

        return [{ lat: bounds.minLat, lng: bounds.minLong }, { lat: bounds.maxLat, lng: bounds.maxLong }];
    }

    getOriginalPolylines() {
        const { form } = this.props;
        const lane = [];
        var originalLaneSegments = [...form.obj.segments];
        for (let i = 0; i < originalLaneSegments.length; i++) {
            const segment = [];
            for (let j = 0; j < originalLaneSegments[i].breakpoints.length; j++) {
                const breakpoint = [originalLaneSegments[i].breakpoints[j].latitude, originalLaneSegments[i].breakpoints[j].longitude];
                segment.push(breakpoint);
            }
            lane.push({ id: originalLaneSegments[i].id, positions: segment });
        }

        return lane;
    }

    // ----------------------------------

    renderMapEditControl() {
        return (
            <EditControl position='topright'
                draw={{
                    polyline: true,
                    polygon: false,
                    rectangle: false,
                    marker: false,
                    circlemarker: false,
                    circle: false,
                }}
                edit={{
                    remove: true,
                }}
                
                onDrawStart={() => this.onChangeEditMapStatus(true)}
                onEditStart={() => this.onChangeEditMapStatus(true)}
                onDeleteStart={() => this.onChangeEditMapStatus(true)}
                onDrawStop={() => this.onChangeEditMapStatus(false)}
                onEditStop={() => this.onChangeEditMapStatus(false)}
                onDeleteStop={() => this.onChangeEditMapStatus(false)}

                onCreated={(e) => this.props.onAddSegmentValue(e)}
                onEdited={(e) => this.props.onEditSegmentsValue(e)}
                onDeleted={(e) => this.props.onDeleteSegmentsValue(e)} />
        );
    }

    renderOriginalPolylines() {
        const originalPolylines = this.getOriginalPolylines();

        if (!Array.isArray(originalPolylines) || 0 === originalPolylines.length) {
            return null;
        }

        return originalPolylines.map((p) =>
            <Polyline positions={p.positions} key={p.id} />
        )
    }

    renderEditionFormGroup(formType, lane) {
        const { form } = this.props;
        const { countyEditions } = this.state;

        if ("create" === formType) {
            return (
                <FormGroup controlId="formEdition" validationState={form.editionInputError}>
                    <ControlLabel>Edição</ControlLabel>
                    <Select
                        className="custom-multiselect"
                        placeholder="Sem Edição"
                        noOptionsMessage={() => "Sem Edições de Rascunho Configuradas"}
                        onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.id, "countyEdition")}
                        options={countyEditions}
                        isMulti={false}
                        isClearable={true}
                        getOptionValue={value => value.id}
                        getOptionLabel={label => label.name}
                        value={countyEditions.find(cEdition => cEdition.id === lane.countyEdition)}
                    />
                    {form.editionInputError !== null
                        ?
                        <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                        :
                        null
                    }
                </FormGroup>
            );
        }

        return null;
    }

    render() {
        const { form } = this.props;

        if (undefined === form) {
            return null;
        }

        const { show } = this.props;
        const { bounds } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {this.renderEditionFormGroup(form.type, form.obj)}

                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formDescription">
                            <ControlLabel>Descrição</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.description}
                                placeholder="Introduza a descrição"
                                onChange={(e) => this.props.onChangeValue(e, "description")}
                            />
                        </FormGroup>
                        <FormGroup controlId="formMap">
                            <LeafletMap className="map-container" bounds={bounds} minZoom={3} maxZoom={18}>
                                <TileLayer
                                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                                <FeatureGroup>
                                    {this.renderMapEditControl()}
                                    {this.renderOriginalPolylines()}
                                </FeatureGroup>
                            </LeafletMap>
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <RefButton ref={this.customRefs.saveChangesButton} onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </RefButton>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}

class RefButton extends Component {
    constructor(props) {
        super(props);

        this.state= {
            disabled: props.disabled
        };
    }

    disabled(bool) {
        this.setState({
            disabled: bool
        });
    }

    render() {
        const { children, onClick } = this.props;
        const { disabled } = this.state;

        return(
            <Button disabled={disabled} 
                onClick={onClick} > 
                {children}
            </Button>
        );
    }
}
